import styled from "styled-components";

const ProgressBarContainer = styled.div<{
  $width: number;
}>`
  border-radius: 2px 0px 0px 2px;
  background-color: var(--surface-container-highest);
  width: 100%;
  height: ${({ $width }) => $width}px;
`;

const ProgressContainer = styled.div<{
  $completePercentage: number;
}>`
  width: ${({ $completePercentage }) => $completePercentage}%;
  background-color: var(--primary);
  height: 100%;
`;

type ProgressBarProps = {
  width: number;
  completePercentage: number;
};

export const ProgressBar: React.FC<ProgressBarProps> = ({
  width,
  completePercentage,
}) => {
  return (
    <ProgressBarContainer $width={width}>
      <ProgressContainer $completePercentage={completePercentage} />
    </ProgressBarContainer>
  );
};
